module.exports = "/_next/static/images/az-39527be08aa5f52eb52149a0062dbfee.svg";